import { Controller } from '@hotwired/stimulus';
import { ToastController } from '@elc-online/edl-components/js/toast';

export default class extends Controller {
  static readonly targets = ['toast', 'close'];

  declare toastTarget: HTMLElement;
  declare closeTarget: HTMLButtonElement;
  declare hasCloseTarget: boolean;

  initialize(): void {
    new ToastController(
      {
        toast: this.toastTarget,
        close: this.hasCloseTarget ? this.closeTarget : null,
      },
      {
        mode: 'auto',
      },
    );
  }
}
